export function isProbablyPhone(input: string) {
  input = input.trim();
  if (!input) {
    return false;
  }

  let digits = 0;
  for (let i = 0; i < input.length; i++) {
    if (input[i] >= '0' && input[i] <= '9') {
      digits++;
    }

    if (digits > 15) {
      return false;
    }
  }

  return digits >= 7;
}
